import { globalCatch } from "../../../../_services/global-catch";
import { toastService } from "../../../../_services/toast-service";
import { t } from "../../../../_i18n";
import { pueCertificatesApi } from "../../../../_services/certificados-pue-service";
import {
    SET_CERTIFICADOS_PUE_STATE,
    SET_CONDICIONES_CERTIFICADOS_PUE_STATE,
    SET_CERTIFICADOS_PUE_CART_STATE
} from "./constants";

export const setCertificadosPueState = payload => ({ type: SET_CERTIFICADOS_PUE_STATE, payload });
export const setCondicionesState = payload => ({ type: SET_CONDICIONES_CERTIFICADOS_PUE_STATE, payload });
export const setCartState = payload => ({ type: SET_CERTIFICADOS_PUE_CART_STATE, payload });

export const getAccountPueCertificatesStudentIdWithSlots = (studentId) => globalCatch.catch(async (dispatch) => {
    const accountPueCertificates = await (await pueCertificatesApi()).getAccountPueCertificatesStudentIdWithSlots(studentId);
    dispatch(setCertificadosPueState(accountPueCertificates));
});

export const getTermsPueCertificates = (studentId) => globalCatch.catch(async dispatch => {
    const termsPueCertificates = await (await pueCertificatesApi()).getTermsPueCertificates(studentId);
    dispatch(setCondicionesState(termsPueCertificates));
});

export const postAccountAcceptTermsPueCertificates = (studentId) => globalCatch.catch(async dispatch => {
    await (await pueCertificatesApi()).postAccountAcceptTermsPueCertificates(studentId);
    dispatch(getTermsPueCertificates(studentId));
});

export const postAccountPueCertificatesEnroll = (studentId, data) => globalCatch.catch(async () => {
  return await (await pueCertificatesApi()).postAccountPueCertificatesEnroll(studentId, data);
});
